import { Locale } from 'src/types'

import { ServiceType } from 'src/pages/ServiceContacts/types'

export const serviceTypeDictionary = (
  locale: Locale['serviceContacts'],
): Record<ServiceType, string> => {
  const { generalMaintenance, bodywork, tireShop } = locale.addServiceContacts

  return {
    [ServiceType.GENERAL_MAINTENANCE]: generalMaintenance,
    [ServiceType.BODYWORK]: bodywork,
    [ServiceType.TIRE_SHOP]: tireShop,
  }
}
